import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledAmountValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '18px',
  fontWeight: 700,
  [theme.breakpoints.down('sm')]: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 700,
  },
}));

export default StyledAmountValue;
